import React from 'react';
import { FormikProps } from 'formik';
import { NSCard, NSDropdown } from 'bricks';
import { IOptionAnyValue, IOptionValue } from 'bricks/types';
import { ProFormaModelIds } from 'constants/proForma';
import { BOESlideoutFormValues } from '../types';
import { getDefaultSubdivsForPropertyType } from '../helpers';

interface IAssetTypeSectionProps {
    formik: FormikProps<BOESlideoutFormValues>;
    proFormaModelOptions: IOptionValue<string>[];
    isEditing?: boolean;
}

const AssetTypeSection: React.FC<IAssetTypeSectionProps> = ({
    formik,
    proFormaModelOptions,
    isEditing,
}) => {
    const { values, setFieldValue } = formik;

    const handlePropertyTypeChange = (option: IOptionAnyValue) => {
        setFieldValue('propertyType', option);

        const defaults = getDefaultSubdivsForPropertyType(Number(option?.value) as ProFormaModelIds);
        setFieldValue('rentPriceSubdiv', defaults.rentPriceSubdiv);
        setFieldValue('expenseCostSubdiv', defaults.expenseCostSubdiv);
        setFieldValue('softCostsSubdiv', defaults.softCostsSubdiv);
        setFieldValue('hardCostsSubdiv', defaults.hardCostsSubdiv);
        if (defaults.resetBedsPerUnit) {
            setFieldValue('bedsPerUnit', null);
        }
    };

    return (
        <NSCard className="p-3 w-50">
            <span className="mr-2 mb-1 text-primary font-weight-bold BOESlideoutForm__title">ASSET TYPE</span>
            <NSDropdown
                options={proFormaModelOptions}
                selectedOption={values.propertyType}
                handleSelectOption={handlePropertyTypeChange}
                customSelectedOptionText={values.propertyType?.label}
                containerClassName="mr-2"
                isFullWidth
                disabled={isEditing}
                toggleClassName="BOESlideoutForm__asset-type-dropdown"
            />
        </NSCard>
    );
};

export default AssetTypeSection;
